import React, { Component } from 'react';
import './Slider.scss'

class slider extends Component {
  render() {
    return (
      <>
        <div className='container-fluid slider_style p-5 slider_bg_color'>
          <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
            <ol className="carousel-indicators">
              <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
              <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
              <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
            </ol>
            <div className="carousel-inner pb-5">
              <div className="carousel-item active">
                <div className="wrapper ">
                  <blockquote className="blockquote text-center">
                  <h1 className='slider_header'>MILESTONES, LIKE NO OTHERS</h1><br></br>
                    <p className="font-italic lead slider_content">
                      THE ONLY FIRM THAT OFFERS WEB APPs & REST APIs FOR ALL ADVISORY MODULES <br></br><br></br>
                      STANDARDIZATION & CUSTOMIZATION GOES HAND IN HAND
                    </p>
                  </blockquote>
                </div>
              </div>
              <div className="carousel-item">
                <div className="wrapper ">
                  <blockquote className="blockquote text-center">
                  <h1 className='slider_header'>MILESTONES, LIKE NO OTHERS</h1><br></br>
                    <p className="font-italic lead slider_content">
                      THE ONLY FIRM THAT OFFERS ALL ADVISORY MODULES VIZ RISK PROFILING,<br></br>
                      GOAL PLANNING & INVESTMENT MANAGEMENT.<br></br> WITH PRIDE & PERFECTION!
                    </p>
                  </blockquote>
                </div>
              </div>
              <div className="carousel-item">
                <div className="wrapper ">
                  <blockquote className="blockquote text-center">
                    <h1 className='slider_header'>MILESTONES, LIKE NO OTHERS</h1><br></br>
                    <p className="font-italic lead slider_content">
                      THE ONLY FIRM FROM INDIA THAT GOT FEATURED IN TRACXN'S<br></br>
                      GLOBAL ROBO ADVISORY REPORT UNDER PRACTICE MANAGEMENT ENABLER CATEGORY.<br></br>
                      AND 1 OF JUST 33 SUCH FIRMS, GLOBALLY!
                    </p>

                  </blockquote>
                </div>
              </div>
            </div>
            <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="sr-only">Previous</span>
            </a>
            <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="sr-only">Next</span>
            </a>
          </div>
        </div>
      </>
    )
  }
}


export default slider